"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyErrorMessage = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const SurveyErrorMessage = (props) => {
    return (react_1.default.createElement("p", { className: "apptr__form-error-message" }, props.containsHtml ? (react_1.default.createElement("span", { dangerouslySetInnerHTML: {
            __html: props.text
        } })) : (props.text)));
};
exports.SurveyErrorMessage = SurveyErrorMessage;
exports.default = exports.SurveyErrorMessage;
//# sourceMappingURL=SurveyErrorMessage.js.map